// Copyright 2012 Traceur Authors.
//
// Licensed under the Apache License; Version 2.0 (the 'License');
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing; software
// distributed under the License is distributed on an 'AS IS' BASIS;
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND; either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

export const $ARGUMENTS = '$arguments';
export const ANY = 'any';
export const APPLY = 'apply';
export const ARGUMENTS = 'arguments';
export const ARRAY = 'Array';
export const AS = 'as';
export const ASYNC = 'async';
export const ASYNC_STAR = 'async star'; // internal kind for async generators
export const AWAIT = 'await';
export const BIND = 'bind';
export const CALL = 'call';
export const CONFIGURABLE = 'configurable';
export const CONSTRUCTOR = 'constructor';
export const CREATE = 'create';
export const CURRENT = 'current';
export const DEFINE_PROPERTY = 'defineProperty';
export const ENUMERABLE = 'enumerable';
export const FREEZE = 'freeze';
export const FROM = 'from';
export const FUNCTION = 'Function';
export const GET = 'get';
export const HAS = 'has';
export const LENGTH = 'length';
export const MODULE = 'module';
export const NEW = 'new';
export const OBJECT = 'Object';
export const OBJECT_NAME = 'Object';
export const OF = 'of';
export const ON = 'on';
export const PREVENT_EXTENSIONS = 'preventExtensions';
export const PROTOTYPE = 'prototype';
export const PUSH = 'push';
export const SET = 'set';
export const SLICE = 'slice';
export const THIS = 'this';
export const TRACEUR_RUNTIME = '$traceurRuntime';
export const TYPE = 'type';
export const UNDEFINED = 'undefined';
export const WRITABLE = 'writable';
